import type { Router } from 'vue-router'

export function installReloadGuards(router: Router) {
  let isGo = false

  router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('token')
    const isLogin = !!token

    isGo = false
    setTimeout(() => {
      if (!isGo) {
        location.reload()
      }
    }, 5000)

    if (isLogin) {
      if (to.name === 'login') {
        next({ name: 'mt' })
      } else {
        next()
      }
      return
    } else if (to.name !== 'login') {
      next()
      return
    }

    next()
  })

  router.beforeResolve(async (to, from, next) => {
    isGo = true
    next()
  })
}

export function installIndexGuards(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const queryTokenArr = to.query.token
    const queryToken = Array.isArray(queryTokenArr) ? queryTokenArr[0] : queryTokenArr || ''
    const storageToken = localStorage.getItem('token')
    const token = queryToken ? queryToken : storageToken

    if (queryToken) {
      localStorage.setItem('token', queryToken)
    }

    const querySessionArr = to.query.session
    const querySession = Array.isArray(querySessionArr) ? querySessionArr[0] : querySessionArr || ''
    if (querySession) {
      const encodedSession = encodeURIComponent(querySession)
      document.cookie = `PHPSESSID=${encodedSession};path=/`
      document.cookie = `OCSESSID=${encodedSession};path=/`
    }

    next()
    return
  })

  router.beforeResolve(async (to, from, next) => {
    next()
  })

  router.afterEach((to) => {
    if (!to.query.token && !to.query.session) return

    const url = new URL(window.location.href)
    const [hashPath, hashQuery = ''] = url.hash.split('?')
    const params = new URLSearchParams(hashQuery)
    params.delete('token')
    params.delete('session')
    url.hash = `${hashPath}${params.toString() ? `?${params.toString()}` : ''}`
    history.replaceState(null, '', url.href)
  })
}
